import { useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";
import useWeb3 from "../hooks/useWeb3";
import { api_url } from "../utils/Enviroment";
import axios from "axios";
import { getSocketOrderWithOptionName, convertFromWei, convertFromWeiEthers } from "../utils/helpers";
import DOMPurify from 'dompurify';

const socket = io(`${api_url}`);

const useSocket = () => {
    const [messagesocketbuy, setMessageSocketBuy] = useState([]);
    const [graph, setGraph] = useState([]);
    const [pools, setPools] = useState([]);
    const [investments, setInvestMents] = useState([]);
    const [closepool, setClosePool] = useState(false);
    const [winnerdecide, setWinnerDecide] = useState([]);
    const [poolsdetail, setPoolsDetail] = useState(null);
    const [openOrders, setOpenOrders] = useState([]);
    const [ordersHistory, setOrdersHistory] = useState([]);
    const [SocketOrderExist, setSocketOrderExist] = useState("");
    const [partiallyFilledOrder, setPartiallyFilledOrder] = useState([]);
    const [disputeEvents, setDisputeEvents] = useState("");
    const [youTubeId, setYoutubeId] = useState("");
    const accessToken = localStorage.getItem("accessToken");
    const [id, setId] = useState("");
    const [exitLiquidityInvestment, setExitLiquidityInvestment] = useState("0");
    const [decideWinnerTime, setDecideWinnerTime] = useState("")
    const [poolDisputed, setPoolDisputed] = useState(false)
    const [isAppealed, setIsAppealed] = useState(false)
    const [appealEvents, setAppealEvents] = useState({})
    const socketQueue = useRef([]);
    const isProcessing = useRef(false);
    const web3 = useWeb3();

    const getPoolsById = async () => {
        if (id) {
            try {
                const url = `${api_url}/pools/pool/${id}`;
                const response = await axios.get(url, {
                    headers: {
                        "Authorization": `Bearer ${accessToken}`,
                        "Content-Type": "multipart/form-data",
                    },
                });
                const poolRes = response?.data?.data
                let sanitizedExplanation
                let updatedPoolRes = {}
                if (poolRes?.consensusExplanation) {
                    sanitizedExplanation = DOMPurify.sanitize(poolRes?.consensusExplanation);
                    updatedPoolRes = {
                        ...poolRes,
                        consensusExplanation: sanitizedExplanation,
                    };
                }
                setPoolsDetail(poolRes?.consensusExplanation ? updatedPoolRes : poolRes)
                setYoutubeId(poolRes?.videoStreamingID);
                setDecideWinnerTime(poolRes?.winnerOption?.createdAt)
                setPoolDisputed(poolRes?.isDisputed)
                setIsAppealed(poolRes?.isAppealed)
            } catch (error) {
                console.error("Error fetching pools:", error);
            }
        }
    };

    const processQueue = () => {
        if (isProcessing.current || socketQueue.current.length === 0) return;

        isProcessing.current = true;
        const { data } = socketQueue.current.shift();

        handleSocketData(data).finally(() => {
            isProcessing.current = false;
            processQueue();
        });
    };

    const handleSocketData = async (data) => {
        setExitLiquidityInvestment((prev) => {
            const updated = Number(prev) + Number(data.totalInvestment);
            return updated.toString();
        });
    };

    useEffect(() => {
        if (id) {
            getPoolsById(id);
        }
    }, [id])


    useEffect(() => {
        if (!poolsdetail) return;

        socket.on('connect', () => {
            console.log('Socket connected:', socket.id);
        });

        socket.on(`enter-option/${poolsdetail?._id}`, (data) => {
            console.log("Enter Option received from server:", data);
            const investments = data?.enterOption?.investment;
            const socketid = data?.pool?._id;
            const totalInvestment = data?.enterOption?.totalInvestment;
            const Totalinvestmentfromwei = convertFromWeiEthers(totalInvestment, data?.pool?.token?.tokenDecimals);

            if (investments && investments.length > 0 && totalInvestment !== undefined) {
                setMessageSocketBuy(prevState => [
                    ...prevState,
                    {
                        id: socketid,
                        investments: investments,
                        totalInvestment: Totalinvestmentfromwei
                    }
                ]);
            }
        });

        socket.on(`sync-price/${poolsdetail?._id}`, (data) => {
            const socketid = data?.pool?._id;
            if (socketid === poolsdetail?._id) {
                console.log("Sync Price Socket", data);
                const pairIndex = parseInt(data?.price?.pair) - 1;
                const percentagesRes = data?.price?.percentage;
                const timestamp = data?.price?.createdAt;
                setGraph(prevGraph => {
                    const updatedGraph = [...prevGraph];
                    if (!updatedGraph[pairIndex]) {
                        updatedGraph[pairIndex] = {
                            percentages: [],
                            timestamps: []
                        };
                    }
                    updatedGraph[pairIndex]?.percentages?.push(percentagesRes);
                    updatedGraph[pairIndex]?.timestamps?.push(timestamp);
                    return updatedGraph;
                });
            } else {
                console.log("Sync price event ignored due to socket id mismatch");
            }
        });


        socket.on(`pool-closed/${poolsdetail?._id}`, (data) => {
            console.log("Pool closed message received:", data);
            const close = data?.pool?.poolFinalized;
            setClosePool(close);
            setPools(close);
            setInvestMents(close);

        });

        socket.on(`winner/${poolsdetail?._id}`, (data) => {
            console.log("Winner message received:", data);
            const winner = data?.pool?.winnerOption;
            setDecideWinnerTime(winner?.createdAt)
            setWinnerDecide(winner)
            setPools(winner);
            setInvestMents(winner);
            setPoolsDetail(prevPool => ({
                ...prevPool,
                winnerOption: {
                    ...prevPool?.winnerOption,
                    decidedBy: winner?.decidedBy
                }
            }));
        })

        socket.on(`order-cancelled/${poolsdetail?._id}`, (data) => {
            console.log("Order Cancel message received:", data);
            const updatedOrder = getSocketOrderWithOptionName(data?.order, data?.pool);
            const tokenDecimal = data?.pool?.token?.tokenDecimals
            updatedOrder.quantity = convertFromWeiEthers(updatedOrder.quantity, tokenDecimal);
            setSocketOrderExist(updatedOrder?.createdAt);
            setOrdersHistory(prev => {
                const exists = prev?.some(order => order._id === data?.order._id);
                return exists ? prev : [...prev, updatedOrder];
            });
            setOpenOrders(prevOpenOrders => {
                const updatedOpenOrders = prevOpenOrders.filter(order => order._id !== updatedOrder._id);
                return updatedOpenOrders;
            });
        });

        socket.on(`order-created/${poolsdetail?._id}`, (data) => {
            console.log("Order Created:", data);
            const updatedOrder = getSocketOrderWithOptionName(data?.order, data?.pool);
            const tokenDecimal = data?.pool?.token?.tokenDecimals
            updatedOrder.quantity = convertFromWeiEthers(updatedOrder.quantity, tokenDecimal);
            setSocketOrderExist(updatedOrder?.createdAt);
            setOpenOrders(prev => {
                const exists = prev?.some(o => o._id === updatedOrder._id);
                return exists ? prev : [updatedOrder, ...prev];
            });
        });

        socket.on(`order-filled/${poolsdetail?._id}`, (data) => {
            setPartiallyFilledOrder(data)
        });

        socket.on(`exit-option/${poolsdetail?._id}`, (data) => {
            const formattedData = data?.exitOption;
            const tokenDecimal = data?.pool?.token?.tokenDecimals
            const convertedData = {
                ...formattedData,
                totalInvestment: convertFromWeiEthers(formattedData?.totalInvestment,tokenDecimal),
            };
            socketQueue.current.push({ data: convertedData });
            processQueue();
        });

        socket.on(`streamingStatusChanged/${poolsdetail?._id}`, (data) => {
            setYoutubeId(data?.videoStreamingID);
        });

        socket.on(`dispute-opened/${poolsdetail?._id}`, (data) => {
            console.log('dispute-opened: ', data);

            setPoolsDetail(prevPool => ({
                ...prevPool,
                winnerOption: {
                    ...prevPool?.winnerOption,
                    decidedBy: data?.pool?.winnerOption?.decidedBy,
                },
                isAiResolver: data?.pool?.isAiResolver,
                status: data?.pool?.status,
            }));

            setPoolDisputed(data?.pool?.isDisputed);
        });

        socket.on(`appeal-opened/${poolsdetail?._id}`, (data) => {
            setAppealEvents({
                eventType: data?.eventType,
            });
            setIsAppealed(data?.pool?.isAppealed)
        });

        socket.on(`dispute-time-extented/${poolsdetail?._id}`, (data) => {
            setDisputeEvents({
                eventType: data?.eventType,
                newEndTime: data?.newEndTime,
            });
        });

        socket.on(`dispute-winner/${poolsdetail?._id}`, (data) => {
            setDecideWinnerTime(data?.pool?.winnerOption?.createdAt)
            setPoolsDetail(prevPool => ({
                ...prevPool,
                winnerOption: {
                    ...prevPool?.winnerOption,
                    decidedBy: data?.pool?.winnerOption?.decidedBy,
                    choiceIndex: data?.pool?.winnerOption?.choiceIndex,
                },
                status: data?.pool?.status,
            }));
        });

        socket.on(`appeal-winner/${poolsdetail?._id}`, (data) => {
            console.log('appeal-winner: ', data);
            setAppealEvents({
                eventType: data?.eventType,
                winnerFinalized: data?.winnerFinalized,
                winnerOption: data?.pool?.winnerOption
            });
        });

        return () => {
            socket.off(`enter-option/${poolsdetail?._id}`)
            socket.off(`sync-price/${poolsdetail?._id}`)
            socket.off(`pool-closed/${poolsdetail?._id}`)
            socket.off(`winner/${poolsdetail?._id}`)
            socket.off(`order-cancelled/${poolsdetail?._id}`)
            socket.off(`order-created/${poolsdetail?._id}`)
            socket.off(`exit-option/${poolsdetail?._id}`)
            socket.off(`streamingStatusChanged/${poolsdetail?._id}`)
            socket.off(`order-filled/${poolsdetail?._id}`)
            socket.off(`dispute-opened/${poolsdetail?._id}`)
            socket.off(`dispute-time-extented/${poolsdetail?._id}`)
            socket.off(`dispute-winner/${poolsdetail?._id}`)
            socket.off(`appeal-opened/${poolsdetail?._id}`)
            socket.off(`appeal-winner/${poolsdetail?._id}`)
        };
    }, [poolsdetail]);

    return {
        messagesocketbuy,
        graph,
        setGraph,
        closepool,
        pools,
        setPools,
        setClosePool,
        winnerdecide,
        setWinnerDecide,
        setPoolsDetail,
        poolsdetail,
        setId,
        id,
        investments,
        setInvestMents,
        getPoolsById,
        setOrdersHistory,
        ordersHistory,
        setOpenOrders,
        openOrders,
        SocketOrderExist,
        youTubeId,
        exitLiquidityInvestment,
        partiallyFilledOrder,
        disputeEvents,
        decideWinnerTime,
        poolDisputed,
        isAppealed,
        appealEvents
    };
};

export default useSocket;
